'use strict';

angular.module('docketbook').
  controller('assignJobModalController', function (addressBookService, userService, jobService, $rootScope, $scope, $state, $stateParams, Restangular, accessControl, $timeout, $q, uuid, docketService) {

    $scope.job = {}
    $scope.personSearchList = []
    $scope.personSearchListFull = []
    $scope.desktopSelected = []
    $scope.originalDesktopSelected = []
    $scope.assigned = []
    $scope.loading = false


    $scope.$parent.showAssignJobModal = function (job) {
      $scope.job = Object.assign({}, job)
      $scope.loadPeopleList();
      $('#acceptOrderWizardModal').fadeIn(100)
    }

    $scope.close = function () {
      $('#acceptOrderWizardModal').fadeOut(100)
    }

    $scope.loadPeopleList = function () {
      $scope.personSearchLoading = true;
      $scope.promise = $q(function (resolve, reject) {
        var queryParams = {};
        if ($stateParams.device == 'desktop') {
          queryParams.limit = $scope.query.limit;
          queryParams.offset = $scope.query.limit * ($scope.query.page - 1);
          queryParams.sort = $scope.query.order;
        }
        if ($scope.searchText != null && $scope.searchText != "") {
          queryParams.search = $scope.searchText;
        }
        userService.getMembers(queryParams, function (returnObject) {
          $scope.personSearchListFull = returnObject;
          $scope.personSearchList = returnObject;
          if (queryParams.offset <= 0 && returnObject.length < queryParams.limit) {
            $scope.listCount = returnObject.length;
          } else {
            $scope.listCount = queryParams.offset + (queryParams.limit + 1);
          }
          for (var i = 0; i < $scope.personSearchList.length; i++) {
            // check if person is in assigned list
            for (var j = 0; j < $scope.assigned.length; j++) {
              if ($scope.assigned[j] == $scope.personSearchList[i].id) {
                $scope.personSearchList[i].assigned = true;
                break;
              }
            }
          }
          $scope.desktopSelected = $scope.job.assignees.map(a => $scope.personSearchList.filter(person => person.id == a.assignee)[0])
          $scope.originalDesktopSelected = $scope.desktopSelected.slice()
          $scope.personSearchList = $scope.personSearchListFull.slice()
          $scope.personSearchLoading = false;
          resolve('Done');
        }, function (err) {
          $scope.personSearchLoading = false;
          $scope.personLoadingError = "Error getting people";
          reject('Error');
        });
      });
    }

    $scope.searchPeopleChange = function (searchText) {
      $scope.searchText = searchText;
      $scope.loadPeopleList();
    }

    $scope.saveJob = function () {
      $scope.loading = true


      var added = $scope.desktopSelected.filter(selected => !$scope.originalDesktopSelected.map(x => x.id).includes(selected.id))
      var removed = $scope.job.assignees.filter(a => !$scope.desktopSelected.map(x => x.id).includes(a.assignee))


      const removePerson = () => {
        if (removed.length > 0) {
          jobService.removeAssignees($scope.job, removed, function () { }, function () { })
        } else {
          sessionStorage.removeItem('jobsList');
          sessionStorage.removeItem('jobsListCount');
          $scope.$parent.$parent.loadJobFromParent($scope.job)
          $scope.$parent.jobsChildControllerReady()

          $('#acceptOrderWizardModal').fadeOut(100)

        }
      }

      if (added.length > 0) {
        jobService.addAssignee($scope.job, added, function () {
          removePerson()
        }, function (err) {
          removePerson()
        })
      } else {
        removePerson()
      }
    }
  })



// WEBPACK FOOTER //
// ./src/controllers/modals/assignJobModalController.js